import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import AlertService from '@/shared/alert/alert.service';
import VisualizadorPdfComponent from '@/components/visualizador-pdf/visualizador-pdf.vue';
import DocumentoService from '@/components/documentos/documento.service';

@Component({
  components: {
    'visualizador-pdf': VisualizadorPdfComponent,
  },
})
export default class VerPdfUrlComponent extends Vue {
  @Inject('documentoService') private readonly documentoService: () => DocumentoService;
  @Inject('alertService') private readonly alertService: () => AlertService;

  @Prop({ required: true })
  public readonly url: string;

  @Prop({
    required: false,
    default: function () {
      return '';
    },
  })
  public readonly tooltip: string;

  @Prop({
    required: false,
    default: function () {
      return '';
    },
  })
  public readonly texto: string;

  @Prop({
    required: false,
    default: function () {
      return 'primary';
    },
  })
  public readonly iconVariant: string;

  @Prop({
    required: false,
    default: function () {
      return 'outline-primary';
    },
  })
  public readonly buttonVariant: string;

  @Prop({ required: false, default: 'file-pdf' })
  public readonly icon: string;

  @Prop({ required: false, default: 'file-earmark-arrow-down' })
  public readonly iconing: string;

  public mostrarPdf = false;
  public consultando = false;
  public contenidoBase64 = '';

  public verPdf(): void {
    this.mostrarPdf = false;
    this.consultando = true;

    this.documentoService()
      .obtenerDocumentoPorUrl(this.url)
      .then(responseDocumento => {
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
        this.mostrarPdf = true;
      })
      .catch(error => {
        this.mostrarPdf = false;
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultando = false;
      });
  }
}
